module.exports = __webpack_public_path__ + "img/(2).50a35370.jpg";